import {GetSeferData} from "SeferPetach/GetData";

export async function getOptionLists(status_id) {
    var args = {STATUS_ID: status_id};
    var payload = await GetSeferData("olf1", args);
    return (payload);
}
export async function getOptionListByID(list_id){
    var args = {
        'OPTION_LIST_ID': list_id
    };
    var payload = await GetSeferData("olf3", args);
    return (payload);
}
export async function updateOptionList(obj){
    var args = obj;
    for (let i  = 0; i < args.ITEMS_LIST.length; i++) {
        args.ITEMS_LIST[i].OPTION_LIST_ITEM_ORDER = i + 1;
    }
    var payload = await GetSeferData("olf2", args);
    return (payload);
}
export async function deleteOptionList(list_id){
    var args = {
        'OPTION_LIST_ID': list_id
    };
    var payload = await GetSeferData("olf4", args);
    return (payload);
}
export async function updateOptionListItem(obj) {
    var args = obj;
    var payload = await GetSeferData("olf6", args);
    return (payload);
    
}
export async function deleteOptionListItem(list_id, item_id) {
    var args = {
        'OPTION_LIST_ID': list_id,
        'OPTION_LIST_ITEM_ID': item_id
    };
    var payload = await GetSeferData("olf5", args);
    return (payload);
}